// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2xQPq","inputWrap":"styles_inputWrap__1AaBJ","input":"styles_input__3ercH"};